import { Gender } from '../types/Gender';

/** Escapes a value for inclusion in a CSV cell. */
export function csvCell(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

/** Triggers a browser download of a CSV string as a file. */
export function downloadCsvBlob(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Normalizes a free-text CSV gender cell ("M", "Women", "lady", ...) to a Gender. Unrecognized
 * values come back undefined rather than being stored raw -- a stray "Women" would otherwise be
 * truthy (so nothing backfills it) yet fail isFemale, scoring her on the men's tees.
 */
export function parseGender(value: string | undefined): Gender | undefined {
  if (!value) return undefined;
  switch (value.trim().toLowerCase()) {
    case 'm': case 'male': case 'man': case 'men': case 'boy': case 'gentleman':
      return 'male';
    case 'f': case 'w': case 'female': case 'women': case 'woman': case 'lady': case 'girl':
      return 'female';
    default:
      return undefined;
  }
}

/** Inverse of parseGender for downloads: the user-facing Men/Women labels, blank when unset or other. */
export function formatGender(gender: Gender | null | undefined): string {
  if (gender === 'male') return 'Men';
  if (gender === 'female') return 'Women';
  return '';
}
